import {
	API_ADMIN_GET_ALL_CAMPAIGNS,
	API_ADMIN_GET_CAMPAIGN,
	API_ADMIN_PATCH_CAMPAIGN,
	API_ADMIN_POST_CAMPAIGN,
	API_ADMIN_DELETE_CAMPAIGN,
	ADMIN_INIT_NEW_CAMPAIGN,
	ADMIN_RESET_FOCUS_CAMPAIGN,
	API_POST_CAMPAIGN_FILE,
	API_GET_CAMPAIGNS_RECORDS_TO_ASSIGN,
	API_GET_CAMPAIGNS_RECORDS_TO_ASSIGN_NEXT,
	API_POST_CAMPAIGN_ASSIGNATION,
	API_PUT_CANCEL_CAMPAIGN_ASSIGNATION,
	API_GET_CAMPAIGN_RESULT_QR_CODE,
	API_SEARCH_CAMPAIGN_RESULTS,
	API_GET_CSV_TEMPLATE,
	API_GET_CAMPAIGNS_RECORDS_PAGE,
	API_GET_CAMPAIGN_EXPORT,
	SET_QR_SEARCH_CAMPAIGN,
} from "actions/campaign";
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";

export const getVersion = (action) => {
	const path = pathMapping[action];
	return {
		path: path ? path[path.currentClient] : undefined,
		currentClient: path ? path.currentClient : DEFAULT_CLIENT,
	}
}

const pathMapping = {
	[API_ADMIN_GET_ALL_CAMPAIGNS]: {
		default: () => `/campaigns`,
		v2: () => `/campaigns`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_GET_CAMPAIGN]: {
		default: (id) => `/admin/campaigns/${id}`,
		v2: (id) => `/campaigns/${id}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_PATCH_CAMPAIGN]: {
		default: () => `/admin/campaign`,
		v2: (id) => `/campaigns/${id}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_POST_CAMPAIGN]: {
		default: (id) => `/admin/campaigns/${id}`,
		v2: () => `/campaigns`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_DELETE_CAMPAIGN]: {
		default: (id) => `/admin/campaigns/${id}`,
		v2: (id) => `/campaigns/${id}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_POST_CAMPAIGN_FILE]: {
		default: (id) => `/admin/campaigns/file/${id}`,
		v2: (id) => `/campaigns/${id}/file`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_CAMPAIGNS_RECORDS_TO_ASSIGN]: {
		default: () => `/campaigns/toassign`,
		v2: () => `/campaigns/toassign`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_CAMPAIGNS_RECORDS_TO_ASSIGN_NEXT]: {
		default: () => `/campaigns/toassign/next`,
		v2: () => `/campaigns/toassign/next`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_POST_CAMPAIGN_ASSIGNATION]: {
		default: (recordId) => `/campaigns/assigned/${recordId}`,
		v2: (recordId) => `/campaigns/assigned/${recordId}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_PUT_CANCEL_CAMPAIGN_ASSIGNATION]: {
		default: (recordId) => `/campaigns/cancel-assigned/${recordId}`,
		v2: (recordId) => `/campaigns/cancel-assigned/${recordId}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_CAMPAIGN_RESULT_QR_CODE]: {
		default: () => `/campaigns/results`,
		v2: () => `/campaigns/results`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_SEARCH_CAMPAIGN_RESULTS]: {
		default: () => `/appointments/campaign`,
		v2: () => `/campaigns/results/search`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_CSV_TEMPLATE]: {
		default: () => `/campaigns/template`,
		v2: () => `/campaigns/template`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_CAMPAIGN_EXPORT]: {
		default: (id) => `/campaigns/${id}/export`,
		v2: (id) => `/campaigns/${id}/export`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_CAMPAIGNS_RECORDS_PAGE]: {
		default: (id) => `/admin/campaigns/${id}/records`,
		v2: (id) => `/campaigns/${id}/records`,
		currentClient: DEFAULT_CLIENT,
	},
};

export function adminGetAllCampaigns() {
	const version = getVersion(API_ADMIN_GET_ALL_CAMPAIGNS);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_ADMIN_GET_ALL_CAMPAIGNS,
		payload: {
			client: version.currentClient,
			request: {
				url,
			},
		},
	};
}

export function adminGetCampaignById(campaignId) {
	const version = getVersion(API_ADMIN_GET_CAMPAIGN);
	const url = typeof version.path === 'function' ? version.path(campaignId) : version.path;
	return {
		type: API_ADMIN_GET_CAMPAIGN,
		payload: {
			client: version.currentClient,
			request: {
				url,
			},
		},
	};
}

export function adminPatchCampaign(campaign) {
	const version = getVersion(API_ADMIN_PATCH_CAMPAIGN);
	const url = typeof version.path === 'function' ? version.path(campaign.id) : version.path;
	return {
		type: API_ADMIN_PATCH_CAMPAIGN,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "PATCH",
				data: campaign,
			},
		},
	};
}

export function adminPostCampaign(campaign) {
	const version = getVersion(API_ADMIN_POST_CAMPAIGN);
	const url = typeof version.path === 'function' ? version.path(campaign.id) : version.path;
	return {
		type: API_ADMIN_POST_CAMPAIGN,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "POST",
				data: campaign,
			},
		},
	};
}

export function adminDeleteCampaign(campaignId) {
	const version = getVersion(API_ADMIN_DELETE_CAMPAIGN);
	const url = typeof version.path === 'function' ? version.path(campaignId) : version.path;
	return {
		type: API_ADMIN_DELETE_CAMPAIGN,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "delete",
			},
		},
	};
}

export function initNewCampaign() {
	return {
		type: ADMIN_INIT_NEW_CAMPAIGN,
	};
}

export function resetFocusCampaign() {
	return {
		type: ADMIN_RESET_FOCUS_CAMPAIGN,
	};
}

export function getCampaignFileCsvToJson(json, campaignId) {
	const version = getVersion(API_POST_CAMPAIGN_FILE);
	const url = typeof version.path === 'function' ? version.path(campaignId) : version.path;
	return {
		type: API_POST_CAMPAIGN_FILE,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "POST",
				data: json,
			},
		},
	};
}

export function getCampaignRecordsToAssign() {
	const version = getVersion(API_GET_CAMPAIGNS_RECORDS_TO_ASSIGN);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_GET_CAMPAIGNS_RECORDS_TO_ASSIGN,
		payload: {
			client: version.currentClient,
			request: {
				url,
			},
		},
	};
}

export function getNextPatientToAssign() {
	const version = getVersion(API_GET_CAMPAIGNS_RECORDS_TO_ASSIGN_NEXT);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_GET_CAMPAIGNS_RECORDS_TO_ASSIGN_NEXT,
		payload: {
			client: version.currentClient,
			request: {
				url,
			},
		},
	};
}

export function saveAssignation(recordId, patient) {
	const version = getVersion(API_POST_CAMPAIGN_ASSIGNATION);
	const url = typeof version.path === 'function' ? version.path(recordId) : version.path;
	return {
		type: API_POST_CAMPAIGN_ASSIGNATION,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "POST",
				data: { patient },
			},
		},
	};
}

export function cancelAssignation(recordId) {
	const version = getVersion(API_PUT_CANCEL_CAMPAIGN_ASSIGNATION);
	const url = typeof version.path === 'function' ? version.path(recordId) : version.path;
	return {
		type: API_PUT_CANCEL_CAMPAIGN_ASSIGNATION,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "PUT",
			},
		},
	};
}

export function getCampaignResultByQrCode(qrcode) {
	const version = getVersion(API_GET_CAMPAIGN_RESULT_QR_CODE);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_GET_CAMPAIGN_RESULT_QR_CODE,
		payload: {
			client: version.currentClient,
			request: {
				url,
				params: {
					qrcode,
				},
			},
		},
	};
}

export function getAllCampaignQR(search) {
	const version = getVersion(API_SEARCH_CAMPAIGN_RESULTS);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_SEARCH_CAMPAIGN_RESULTS,
		payload: {
			client: version.currentClient,
			request: {
				url,
				params: {
					search,
				},
			},
		},
	};
}

export function getCsvTemplate() {
	const version = getVersion(API_GET_CSV_TEMPLATE);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_GET_CSV_TEMPLATE,
		payload: {
			client: version.currentClient,
			request: {
				url,
			},
		},
	};
}

export function getCampaignExport(campaignId) {
	const version = getVersion(API_GET_CAMPAIGN_EXPORT);
	const url = typeof version.path === 'function' ? version.path(campaignId) : version.path;
	return {
		type: API_GET_CAMPAIGN_EXPORT,
		payload: {
			client: version.currentClient,
			request: {
				url,
			},
		},
	};
}

export function loadListRecords(campaignId, page = 1) {
	const version = getVersion(API_GET_CAMPAIGNS_RECORDS_PAGE);
	const url = typeof version.path === 'function' ? version.path(campaignId) : version.path;
	return {
		type: API_GET_CAMPAIGNS_RECORDS_PAGE,
		payload: {
			client: version.currentClient,
			request: {
				url,
				params: {
					page,
				},
			},
		},
	};
}

export function qrSearchCampaign(qr) {
	return {
		type: SET_QR_SEARCH_CAMPAIGN,
		data: qr,
	};
}
